import axios from 'axios';
import { config } from '../../../config/env';
import { OabResolveOfferRequest, OabResolveOfferResponse } from './types';

const baseUrl = config.jusfyBackend.apiUrl;
const resolveOfferUrl = `${baseUrl}/oab/resolve-offer`;

export async function resolveOabOffer(
  payload: OabResolveOfferRequest,
): Promise<OabResolveOfferResponse> {
  const { data } = await axios.post<{ success: true; data: OabResolveOfferResponse }>(
    resolveOfferUrl,
    payload,
  );
  return data.data;
}
